import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuthFetch } from '../hooks/useAuthFetch';

const CurrencyContext = createContext('EUR');

export function CurrencyProvider({ children }) {
  const authFetch = useAuthFetch();
  const [currency, setCurrency] = useState('EUR');

  useEffect(() => {
    authFetch('/api/currency')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => { if (data?.currency) setCurrency(data.currency); })
      .catch(() => {/* keep default EUR */});
  }, [authFetch]);

  return (
    <CurrencyContext.Provider value={currency}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
